import React, { useEffect, useState } from 'react'
import { compose } from 'recompose'
import { useTheme, Grid, Typography, Button, Paper, Avatar } from '@material-ui/core'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import LoginPagesWrapper from '../../../components/LoginPagesWrapper'
import Stepper from '../../../components/StepperV2'
import { makeStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router'
import { getPatient, fetchCountriesByLocale, updatePatientFirstTouch, fetchTerms, getOwnerMFAState, showModal, getCreatorInfoByEmail, getCreatorInfo } from '../../../redux/actions'
import { countryListSelector, patientSelector, termsSelector, thirdPartyTermsSelector, ownerMFAStateSelector, userSelector } from '../../../redux/selectors'
import { connect, useDispatch } from 'react-redux'
import FormTextField from '../../../components/FormTextField'
import FormDateField from '../../../components/FormDateField'
import { reduxForm, change, formValueSelector } from 'redux-form'
import { required, birthDate, phoneNumber, date, minDateValue } from '../../../utilties/validators'
import Logo from '../../../assets/logo'
import { injectIntl } from 'react-intl'
import { PhoneNumberField } from '../../../components/PhoneNumberField'
import CountrySelector from '../../../components/CountrySelector'
import translations from '../../../utilties/languages/locales'
import * as cookies from '../../../utilties/cookies'
import locale2 from 'locale2'
import queryString from 'query-string'
import RegistrationPagesWrapper from '../../../components/RegistrationPagesWrapper'
import { getUser } from '../../../utilties/userUtilities'

const requiredValidator = required
const birthDateValidator = birthDate
const phoneNumberValidator = phoneNumber
const dateValidator = date
const treatmentMinValueValidator = minDateValue('commencementDate')

const useStyles = makeStyles((theme) => ({
	gridStyle: {
	  padding: '6rem',
	  width: '100%',
	  margin: '0',
	  boxSizing: 'border-box',
	  display: 'flex',
	  flexDirection: 'column',
	  alignItems: 'center',
	  [theme.breakpoints.down('sm')]: {
		padding: '3rem 2rem',
	  }
	},
	avatar: {
		width: 23,
		height: 23,
		backgroundColor: '#7ab5e0',
		color: '#011020',
		fontSize: '1em',
		lineHeight: '23px'
	},

}))

const selector = formValueSelector('welcome')

const getLocale = () => {
	  let locale = 'en';
      let localeCookie = cookies.get('languageAbbreviation');

      if (localeCookie) {
          locale = localeCookie;
      }
	  else if (locale2) {
		  locale = locale2.substring(0, 5)
		  if (locale !== 'en-GB') {
			  locale = locale2.substring(0, 2)
		  }
	  }

      if (!translations[locale]) {
          locale = 'en'
      }

      return locale;
}

const TermsDialog = ({
	internalTerms
}) => {
	return (
		<div
			style={{
				width: '80vw',
				height: '80vh',
				padding: '16px',
				margin: '0', 
				display: 'block'
			}}
		>
			<span dangerouslySetInnerHTML={{ __html: internalTerms }} />
		</div>
	)
}

const Welcome = ({
	loadTerms,
	patient,
	internalTerms,
	handleSubmit,
	intl,
	location,
	loadCountries,
	countries,
	loadPatient,
	updatePatient,
	firstName,
	lastName,
    countryId,
	phoneNumber,
	dob,
	ownerMFAState,
	loadOwnerMFAState,
	history,
	getCreatorInfo
}) => {
	
	const dispatch = useDispatch()
    const theme = useTheme()
	const classes = useStyles()

	const [ user, setUser ] = useState(getUser())
	const [ canBack, setCanBack ] = useState(false)
    const [showCreatorInfoPanel, setShowCreatorInfoPanel] = useState(false)


	const onSubmitForm = (values) => {
		updatePatient({
			birthDate: values.birthDate,
			firstName: values.firstName,
			lastName: values.lastName,
			middleName: values.middleName,
			phoneNumber: values.phoneNumber,
			phoneCountryCode: values.phoneCountryCode,
			countryId: values.countryId,
			treatmentDate: values.treatmentDate,
		})
	}

	useEffect(() => {
		loadCountries(getLocale())
		loadPatient()
		loadOwnerMFAState()

		const values = queryString.parse(location.search)
		setCanBack(!!values.data)
	}, [])

	useEffect(() => {
        if (!internalTerms && patient) {
			if(patient.circleId) {
				loadTerms(patient.circleId, getLocale())
			} else {
				loadTerms(0, getLocale())
			}
        }

		if (!!patient) {
			dispatch(change('welcome', 'firstName', patient.firstName))

			dispatch(change('welcome', 'middleName', patient.middleName))

			dispatch(change('welcome', 'lastName', patient.lastName))

			dispatch(change('welcome', 'birthDate', patient.birthDate))

			dispatch(change('welcome', 'countryId', patient.countryId || countryId))

			dispatch(change('welcome', 'phoneNumber', patient.phoneNumber))

			dispatch(change('welcome', 'treatmentDate', patient.treatmentDate))

			dispatch(change('welcome', 'commencementDate', patient.commencementDate))
		}

	}, [patient && patient.circleId])
	
	useEffect(
		() => {
			if (!!user) {
				getCreatorInfo(user.email)
				setShowCreatorInfoPanel(true)
			}
		},
		[user]
	)


	const showTerms = () => {
		dispatch(
			showModal(
				TermsDialog,
				{
					internalTerms,
					disableBackdropClick: true
				},
				true
			)
		)
	}

	const onGoBack = () => {
		if (canBack) {
			const query = queryString.parse(location.search)

			history.push(`/auth/emailVerification?data=${query.data}`)
		}
	}

	const AgreementsLabel = ({}) => {
		return (
			<a
				href="#"
				onClick={showTerms}
			>
				{intl.formatMessage({ id: 'app.welcome.personalDetails.agreementsLabel' })}
			</a>
		)
	}

    return (
		<LoginPagesWrapper>
			<RegistrationPagesWrapper
				showCreatorInfoPanel={true}
			>
				<form data-testid="form-welcome" onSubmit={handleSubmit(onSubmitForm)}
					style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
					<Paper className={classes.gridStyle} elevation={2}>
						<Grid item style={{ paddingBottom: '20px' }} align='center'>
							<Logo />
						</Grid>
						<Grid item style={{ paddingBottom: '20px' }}>
							<Typography data-testid="form-welcome-title" variant="h3" style={{ fontWeight: '500' }} align='center'>
								{intl.formatMessage({ id: 'app.welcome.title' })}
							</Typography>
						</Grid>
						<Grid item style={{ width: '100%', paddingBottom: '40px' }}>
							<Typography data-testid="form-welcome-paragraph" variant='body1' align='center'>
								<span dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'app.welcome.personalDetails.paragraphStart' }) }} />
								<AgreementsLabel />
								<span dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'app.welcome.personalDetails.paragraphEnd' }) }} />
							</Typography>
						</Grid>
						<Grid item style={{ width: '100%' }}>
							<Grid container style={{ display: 'block' }}>
								<Grid item style={{ padding: '10px 0', marginBottom: '15px' }}>
									<Grid container direction='row'>
										<Grid container spacing={1}>
											<Grid item xs={12} sm={12} className="global-input-wrapper">
												<FormTextField
													data-testid="input-firstname"
													label={intl.formatMessage({ id: 'app.welcome.firstName' })}
													type='text' variant='filled' maxLength={254} validators={[requiredValidator]}
													name='firstName'
												/>
											</Grid>
											<Grid item xs={12} sm={12} className="global-input-wrapper">
												<FormTextField
													label={intl.formatMessage({ id: 'app.welcome.middleName' })}
													type='text' variant='filled' maxLength={254}
													name='middleName'
												/>
											</Grid>
											<Grid item xs={12} sm={12} className="global-input-wrapper">
												<FormTextField
													data-testid="input-lastname"
													label={intl.formatMessage({ id: 'app.welcome.lastName' })}
													type='text' variant='filled' maxLength={254} validators={[requiredValidator]}
													name='lastName'
												/>
											</Grid>
											<Grid item xs={12} sm={12} className="global-input-wrapper">
												<FormDateField
													data-testid="input-birth-date"
													label={intl.formatMessage({ id: 'app.welcome.birthDate' })}
													fullWidth type='text' variant='filled' validators={[requiredValidator, birthDateValidator]}
													name='birthDate'
													openToYear={true}
												/>
											</Grid>
											<Grid item xs={12} sm={12} style={{ minHeight: '90px' }}>
												<CountrySelector
													data-testid="input-country-name"
													suggestions={countries}
													label={intl.formatMessage({ id: 'app.welcome.country' })}
													style={{ color: 'black', paddingBottom: '10px' }}
													validators={[requiredValidator]}
													name='countryId'
												/>
											</Grid>
											<Grid item xs={12} sm={12} className="global-input-wrapper phone-input-light">
												<PhoneNumberField
													data-testid="input-phone-number"
													label={intl.formatMessage({ id: 'app.welcome.phone' })}
													name='phoneNumber'
													phoneField='phoneNumber'
													phoneCountryCodeField='phoneCountryCode'
													validators={[requiredValidator, phoneNumberValidator]}
												/>
											</Grid>
											{patient && patient.isSelfOnboarding && <Grid item xs={12} sm={12} className="global-input-wrapper">
												<FormDateField
													data-testid="input-treatment-date"
													label={intl.formatMessage({ id: 'app.welcome.treatmentDate' })}
													fullWidth type='text' 
													variant='filled' 
													validators={[requiredValidator, dateValidator, treatmentMinValueValidator]}
													name='treatmentDate'
													disablePast={true}
												/>
											</Grid>}
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
						<Grid item style={{ width: '100%' }} />
						<div
							className="stepper-register-wrapper"
							style={{ paddingTop: '20px' }}>
							<div className="stepper-register-next">
								<Button
									data-testid="form-next-button"
									type='submit'
									variant='contained'
									color='primary'
									size='small'
									disabled={!(firstName && lastName && countryId && phoneNumber && dob)}
									endIcon={<KeyboardArrowRight />}
									style={{
										marginTop: '8px'
									}}
								>
									{intl.formatMessage({ id: 'app.welcome.buttonText' })}								
								</Button>
							</div>
							<div className="stepper-register-step">
								<Stepper stepsCount={3 + (ownerMFAState ? 1 : 0)} selectedStep={2} stepNumber={2} />
							</div>
							<div className="stepper-register-back">
								{
									canBack
									&& <Button
										data-testid="form-back-button"
										variant='outlined'
										color='primary'
										size='small'
										disabled={!canBack}
										startIcon={<KeyboardArrowLeft />}
										onClick={onGoBack}
									>
										{intl.formatMessage({ id: 'app.general.back' })}
									</Button>
								}
							</div>							

						</div>
					</Paper>
				</form>
			</RegistrationPagesWrapper>
		</LoginPagesWrapper>
	)
}

const mapStateToProps = (state, ownProps) => ({
	internalTerms: termsSelector(state),
	thirdPartyTerms: thirdPartyTermsSelector(state),
	patient: patientSelector(state),
	countries: countryListSelector(state),
	initialValues: patientSelector(state),
	firstName: selector(state, 'firstName'),
	lastName: selector(state, 'lastName'),
	countryId: selector(state, 'countryId'),
	phoneNumber: selector(state, 'phoneNumber'),
	dob: selector(state, 'birthDate'),
	internalTermsField: selector(state, 'internalTermsField'),
	thirdPartyTermsField: selector(state, 'thirdPartyTermsField'),
	ownerMFAState: ownerMFAStateSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	change: (name, value) => dispatch(change('welcome', name, value)),
	loadTerms: (circleId, language) => dispatch(fetchTerms(circleId, language)),
	loadPatient: () => dispatch(getPatient()),
	loadCountries: (locale) => dispatch(fetchCountriesByLocale(locale)),
	setCountry: (countryId) => dispatch(change('welcome', 'countryId', countryId)),
	loadOwnerMFAState: () => dispatch(getOwnerMFAState()),
	updatePatient: (patient) =>
		dispatch(
			updatePatientFirstTouch(patient)
		),
	getCreatorInfo: (email) => dispatch(getCreatorInfo(email)),
})

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	injectIntl,
	reduxForm({
		form: 'welcome',
		touchOnChange: true,
		touchOnBlur: true,
		// enableReinitialize: true
	}),
	withRouter
)

export default enhance(Welcome)
